import {Disposable, Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {EnterReportDraftInput, EnterReportDraftMutation} from './__generated__/EnterReportDraftMutation.graphql';

const mutation = graphql`
	mutation EnterReportDraftMutation($input: EnterReportDraftInput!) {
		enterReportDraft(input: $input) {
			draftState
			publishedAt
			locked
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<EnterReportDraftInput>,
	onSuccess?: RelayOnCompleted<EnterReportDraftMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
